import { postJSON } from 'common/services/api'
import { useMutation, useQueryClient } from 'react-query'
import {
  ALLOCATE_CARER_QUERY_KEY,
  ALLOCATE_CARER_URL,
  ALLOCATION_LIST_QUERY_KEY,
  REVISION_QUERY_KEY,
  REVISIONS_QUERY_KEY,
} from './queryConstants'

type UseAllocateCarer = {
  allocateCarer: (values: any) => void
  isAllocateLoading?: boolean
}

type UseAllocateCarerProps = {
  id?: string
  onSuccess?: () => void
}

const useAllocateCarer = ({
  id,
  onSuccess,
}: UseAllocateCarerProps): UseAllocateCarer => {
  const queryClient = useQueryClient()

  const createFunction = async (values: any) => {
    return postJSON({
      url: `${ALLOCATE_CARER_URL}/${id}`,
      method: 'POST',
      json: values,
      isRota: true,
    })
  }

  const { mutateAsync: createMutation, isLoading: isAllocateLoading } =
    useMutation<any, unknown, any, unknown>(
      [ALLOCATE_CARER_QUERY_KEY],
      createFunction,
      {
        onSuccess: () => {
          onSuccess?.()
          queryClient.invalidateQueries([ALLOCATION_LIST_QUERY_KEY])
          queryClient.invalidateQueries([REVISIONS_QUERY_KEY])
          queryClient.invalidateQueries([REVISION_QUERY_KEY, id])
        },
      }
    )

  const allocateCarer = async (values: any) => {
    try {
      const result = await createMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    allocateCarer,
    isAllocateLoading,
  }
}

export default useAllocateCarer
